
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class TaxDetailsGrid extends Serenity.EntityGrid<TaxDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.TaxDetails'; }
        protected getDialogType() { return TaxDetailsDialog; }
        protected getIdProperty() { return TaxDetailsRow.idProperty; }
        protected getInsertPermission() { return TaxDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return TaxDetailsRow.localTextPrefix; }
        protected getService() { return TaxDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}